<template>
  <div class="aboutApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='5'></headComponent>
    <div class="h"></div>
    <div class="proBg"  :style="'background: url('+usbg+') no-repeat center;'">
      <div class="txt">
        <h2 class="tit">关于我们</h2>
        <div class="desc"><p>{{setAbout.title}}</p></div>
      </div>
    </div>

    <div class="main">
      <h2>公司介绍</h2>
      <div v-html="setAbout.content"></div>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        usbg:require('../../../assets/images/us1.png'),
        setAbout:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getAbout();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getAbout:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/about',
          dataType:'json',
          success:function(data){
            that.setAbout = data.data;
            that.fullscreenLoading = false;
          }
        })
      },

    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .aboutApp .el-message-box{
    width:30%
  }
  .aboutApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .aboutApp .h{
    height:96px
  }
  .aboutApp .proBg{
    height: 35.06vw;
    color:#fff;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .aboutApp .proBg .txt{
    position: absolute;
    top: 50%;
    color: #fff;
    transform: translateY(-50%);
    left: 8.333vw;
  }
  .aboutApp .proBg .txt .tit{
    font-size: 3vw;
    margin-bottom:20px;
    font-weight: normal;
  }
  .aboutApp .proBg .txt .desc {
    font-size: 16px;
    width:75%;
    line-height:28px
  }

  .aboutApp .main{
    margin:0 auto;
    max-width:1600px;
  }
  .aboutApp .main h2{
    text-align:center;
    padding:30px 0
  }
  .aboutApp .main p{
    font-size:16px;
    line-height:25px;
    text-align: justify;
    text-indent: 2em;
    width:80%;
    margin:0 auto 15px auto
  }
  .aboutApp .main img{
    margin:0 auto;
    display:block;
  }
  
  
  @media only screen and (max-width: 1199px) {
    .aboutApp .header,.aboutApp .h{
      height:60px;
    }
    .aboutApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .aboutApp .header .nav{
      text-align:right
    }
    .aboutApp .header .nav li{
      margin:0 1.8vw
    }
    .aboutApp .header .nav .close{
      display:none
    }
    .aboutApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .aboutApp .proBg{
      font-size:18px;
    }
    .aboutApp .main dl dd{
      width:50%
    }
  } 
</style>